import React, { useEffect } from 'react';
import FormSender from '../components/orderPage/formSender/FormSender';
import { useParams } from 'react-router';

const CONFIG = {
  ro: {
    title: 'Cum funcționează cursul VorbiGo',
    description: 'Ești interesat de curs? Ai dori mai multe informații?',
  },
};

const OrderPage = ({ data }) => {
  const { lang } = useParams();

  useEffect(() => {
    document.title = CONFIG[lang]?.title;
  }, [lang]);

  return (
    <div>
      <FormSender data={data.formControll} />
    </div>
  );
};

export default OrderPage;
